
/**
 * Module dependencies.
 */

import { QueryObserverBaseResult, useQuery } from 'react-query';
import { fetchFaq } from './fetch-faq';
import { useMemo } from 'react';
import { useRouter } from 'next/router';

/**
 * `Props` type.
 */

type Props<P> = QueryObserverBaseResult<P, unknown>;

/**
 * `Options` type.
 */

type Options<P> = {
  initialData?: P | null,
  slug: string
};

/**
 * Action type.
 */

export const actionType = ({ locale, slug }): string => {
  return `${locale}-faq-${slug}`;
};

/**
 * `useFaq` hook.
 */

function useFaq<P>({ initialData, slug }: Options<P>): Props<P> {
  const { locale } = useRouter();
  const variables = useMemo(() => ({ locale, slug }), [locale, slug]);
  const result = useQuery([actionType(variables), variables], () => {
    return fetchFaq(variables);
  }, {
    initialData
  });

  return result;
}

/**
 * Export `useFaq` hook.
 */

export default useFaq;
